import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceService } from '../../../providers/invoice.service';

@Component({
  selector: 'app-pay',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.scss']
})
export class PayComponent implements OnInit {
  errorMsg;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public translator: TranslateService,
    public invoiceService: InvoiceService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const invoiceId = +params['id'];
      this.invoiceService.payInvoice(invoiceId).subscribe({
        next: (result: any) => {
          if (result.credit) {
          } else if (result.gate) {
            switch (result.gate) {
              case 'ASP':
                const params = new URL(result.redirectUrl).searchParams;
                const RefId = params.get('RefId');
                const mobileap = params.get('mobileap');
                this.postRefId(RefId, mobileap)
                break;
              // case 'BPM':
              //   const refId = jsonResult.return.toString().split(',')[1];
              //   this.redirectMellat(refId);
              //   break;
              case 'SEP':
                this.redirectSaman(result.redirectUrl, result.amount, result.mid, result.resNum);
                break;
              default:
                if (result.redirectUrl) {
                  window.location.href = result.redirectUrl;
                } else {
                  this.errorMsg = this.translator.instant('GATE_EMPTY_REDIRECT');
                }
                break;
            }
          } else {
            this.errorMsg = this.translator.instant('GATE_EMPTY');
          }
        }, error: error => {
          this.errorMsg = this.describeError(error);
        }
      });
    });
  }

  /**
   * Show what the API actually said. On an HttpErrorResponse `.message` is
   * Angular's own English summary ("Http failure response for ...: 500
   * Internal Server Error"); the reason the customer needs -- e.g. "پیش فاکتور
   * مورد نظر وجود ندارد." -- is in `.error`, as either a bare string or a
   * `{message}` object.
   */
  private describeError(error: any): string {
    const body = error && error.error !== undefined ? error.error : error;
    const raw = (body && typeof body === 'object') ? (body.message || body.error) : body;
    const text = (typeof raw === 'string' && raw.trim()) ? raw.trim() : null;
    if (!text) {
      return this.translator.instant('GENERAL_ERROR');
    }
    // instant() returns the key unchanged when it is not a known token, so a
    // ready-made sentence from the API passes straight through.
    return this.translator.instant(text);
  }

  redirectMellat(refId) {
    if (refId) {
      const pageContent = `<html dir="rtl">
        <head>
                <title>پرداخت</title>
        </head>
        <body>
          <div style="text-align: center; margin-top: 30px;">
            <img style="position:relative; top : 46%;  display:block; margin:0px auto;" src="../assets/images/logo/petiak.png" />
            <h2>در حال هدایت به درگاه بانک ...</h2>
                <form name="form" id="form" action="https://bpm.shaparak.ir/pgwchannel/startpay.mellat" method="post">
                        <input type="hidden" id="refId" name="RefId" value="${refId}" style="display: none;"/>
                        <input type="submit" id="submit" value="تایید"/>
                </form>
          </div>
        </body>
        </html>`;
      window.document.body.innerHTML = pageContent;
      window.document.getElementById('submit').click();
    }
  }

  redirectSaman(redirectUrl, amount, mid, resNum) {
    if (redirectUrl && amount && mid && resNum) {
      const pageContent = `<html dir="rtl">
        <head>
                <title>پرداخت</title>
        </head>
        <body>
        <img style="position:relative; top : 46%;  display:block; margin:0px auto;" src="../assets/images/logo/petiak.png" />
                <form name="form" id="form" action="https://sep.shaparak.ir/Payment.aspx" method="post">
                        <input type="text" id="RedirectURL" name="RedirectURL" value="${redirectUrl}" style="display: none;"/>
                        <input type="text" id="Amount" name="Amount" value="${amount}" style="display: none;" />
                        <input type="text" id="ResNum" name="ResNum" value="${resNum}" style="display: none;"/>
                        <input type="text" id="MID" name="MID" value="${mid}" style="display: none;"/>
                        <input type="submit" id="submit" name="submit" style="display: none;"/>
                </form>
        </body>
        </html>`;
      // const win = window.open('', '_blank');
      // if (win) {
      //   win.document.body.innerHTML = pageContent;
      //   win.document.getElementById('submit').click();
      // } else {
      //   // showing alert
      // }
      window.document.body.innerHTML = pageContent;
      window.document.getElementById('submit').click();
    }
  }

  redirectPasargad(token) {
    if (token) {
      const pageContent = `<html dir="rtl">
        <head>
                <title>پرداخت</title>
        </head>
        <body>
        <img style="position:relative; top : 46%;  display:block; margin:0px auto;" src="../assets/images/logo/petiak.png" />
                <form name="form" id="form" action="https://pep.shaparak.ir/payment.aspx" method="post">
                        <input type="hidden" name="Token" value="${token}" />
                        <input type="submit" id="submit" value="تایید" style="margin:0px auto;"/>
                </form>
        </body>
        </html>`;
      window.document.body.innerHTML = pageContent;
      window.document.getElementById('submit').click();
    }
  }

  return() {
    this.router.navigate(['']);
  }

  postRefId(refIdValue, mobileap) {
    var form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", "https://asan.shaparak.ir");
    form.setAttribute("target", "_self");

    var refIdField = document.createElement("input");
    refIdField.setAttribute("name", "RefId");
    refIdField.setAttribute("value", refIdValue);
    form.appendChild(refIdField);

    var mobileField = document.createElement("input");
    mobileField.setAttribute("name", "mobileap");
    mobileField.setAttribute("value", mobileap);
    form.appendChild(mobileField);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
